export default "__VITE_ASSET__D0K$ZUxM__"